import { TableColumn } from "./dataInterface";

export const screenColumnConfigTableColumn: TableColumn = {
  title: "システム項目設定一覧",
  detail: false,
  detailTitle: "システム項目設定詳細",
  detailColumn: "詳細",
  detailKey: ["id"],
  addTitle: "システム項目設定登録",
  editAuth: [],
  tableFunction: [
    {
      name: "項目削除",
      width: "60px",
      auth: ["マスターアカウント", "スタッフアカウント"],
    },
  ],
  postCSVTitle: "",
  dataColumn: [
    {
      key: "screen_name",
      name: "画面名",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: true,
      tableMinWidth: "120px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "list",
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: true,
      addType: "list",
      addMessage: "",
    },
    {
      key: "screen_column_name",
      name: "項目名",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "bubun",
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: true,
      addType: "text",
      addMessage: "",
    },
    {
      key: "screen_column_system_default",
      name: "デフォルト",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: true,
      tableMinWidth: "100px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "list",
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "screen_column_auth",
      name: "表示権限",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "200px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "list",
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: true,
      addType: "list",
      addMessage: "",
    },
    {
      key: "login_sale_company",
      name: "ログインパートナー",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "200px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "company",
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: true,
      addType: "list",
      addMessage: "",
    },
    {
      key: "login_collaborate_company",
      name: "協業パートナー",
      tableDetailAuth: [],
      table: false,
      tableMinWidth: "130px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editType: null,
      editId: "",
      add: true,
      addType: "list",
      addMessage:
        "※登録後、パートナーの設定を変更したい場合は管理者に問い合わせください。",
    },
    {
      key: "screen_column_type",
      name: "項目タイプ",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: true,
      tableMinWidth: "100px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "list",
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: true,
      addType: "list",
      addMessage: "",
    },
    {
      key: "screen_column_selects",
      name: "選択肢一覧",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: false,
      tableMinWidth: "100px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: "list",
      detail: false,
      edit: false,
      editType: null,
      editId: "",
      add: true,
      addType: "screen_column_selects",
      addMessage: "",
    },
  ],
  subTable: [
    {
      subTableAuth: ["マスターアカウント", "スタッフアカウント"],
      mainTableDetail: false,
      mainTableDetailColumn: "",
      subTableColumnName: "ログインパートナー一覧",
      subTableColumnLength: "login_company_length",
      subTableColumnNameWidth: "160px",
      detailKey: ["id"],
      subTableDetail: false,
      subTableDetailTitle: "ログインパートナー詳細",
      subTableAdd: true,
      subTableAddTitle: "ログインパートナー追加",
      subTableAddTitleWidth: "160px",
      subTableEdit: false,
      subTableEditTitle: "ログインパートナー編集",
      subTableEditDirect: false,
      subTableEditDirectKey: "",
      subTableEditAuth: ["マスターアカウント", "スタッフアカウント"],
      tableFunction: [],
      subDataColumn: [
        {
          key: "login_sale_company_name",
          name: "ログインパートナー名",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: true,
          addType: "login_sale_company",
          addMessage: "※システム項目を設定するパートナーを設定できます。",
        },
      ],
      subTable: [],
    },
    {
      subTableAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      mainTableDetail: false,
      mainTableDetailColumn: "",
      subTableColumnName: "選択肢一覧",
      subTableColumnLength: "screen_column_select_length",
      subTableColumnNameWidth: "85px",
      detailKey: ["id"],
      subTableDetail: false,
      subTableDetailTitle: "選択肢詳細",
      subTableAdd: true,
      subTableAddTitle: "選択肢追加",
      subTableAddTitleWidth: "85px",
      subTableEdit: false,
      subTableEditTitle: "選択肢編集",
      subTableEditDirect: false,
      subTableEditDirectKey: "",
      subTableEditAuth: ["マスターアカウント", "スタッフアカウント"],
      tableFunction: [],
      subDataColumn: [
        {
          key: "screen_column_select",
          name: "選択肢",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: true,
          addType: "screen_column_select",
          addMessage: "",
        },
      ],
      subTable: [],
    },
  ],
};
